<template>
  <section class="container">
    <CoolLightBox 
      :items="items" 
      :index="index"
      loop
      @close="index = null">
    </CoolLightBox>
    <full-page ref="fullpage" :options="options">
      <div
        class="section"
        id="section1d2b"
        data-anchor="d2b1"
        style="margin-bottom:15px;"
      >
        <div class="fp-bg"></div>
        <div class="headerProyecto-d2b" id="headerProy">
          <v-container fluid>
            <v-row>
              <v-col cols="2"></v-col>
              <v-col cols="6">
                <v-row>
                  <div
                    class="titulo-proyecto-d2b"
                    style="position: absolute; font-family: 'Didot-bold'; color: black !important; font-size: calc(14.5px + 2.18125vw); z-index: 9999; opacity: 1;"
                  >
                    <p>Oficina D2B</p>
                  </div>
                </v-row>
                <v-row>
                  <div
                    style="position: relative; top:25vh; left: 10vw; font-family: 'Source'; color: black; font-size: calc(10.5px + 1.08125vw);"
                  >
                    Remodelación planta libre oficinas D2B
                  </div>
                </v-row>
                <v-row>
                  <div
                    style="position: relative; top:25vh; left: 10vw; font-family: 'Source'; color: black; font-size: calc(6.5px + 0.8125vw);">
                    Proyecto no ejectuado - Solo propuesta de diseño
                  </div>
                </v-row>
                <v-row>
                  <div
                    style="position: relative; top:25vh; left: 10vw; font-family: 'Source'; color: black; font-size: calc(8.5px + 1.08125vw);"
                  >
                    Santiago 2020
                  </div>
                </v-row>
                <v-row>
                  <v-btn class="boton-volver-d2b" to="/proyectos">Volver</v-btn>
                  <!--           <div>
                  <v-icon large style="position:absolute; bottom:1vh; left: 50vw; transition: all 0.45s ease-in-out;" @click="toggleCabProy()" v-if="cabeceraIsVisible" color="#372b5d">mdi-chevron-up</v-icon>
                  <v-icon large style="position:absolute; bottom:1vh; left: 50vw; transition: all 0.45s ease-in-out;" @click="toggleCabProy()" v-if="!cabeceraIsVisible" color="#372b5d">mdi-chevron-down</v-icon>
                  </div>-->
                </v-row>
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>
          </v-container>
        </div>
        <div class="slide" id="slide1-4">
          <div class="fp-bg"></div>
        </div>
      </div>

      <div class="section" id="section2d2b" data-anchor="d2b2">
        <v-container fluid>
          <v-row>
            <v-col cols="6">
              <v-img :src="image_srcd2b2" class="img-d2b2" contain @click="setIndex(1)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>

            <v-col cols="6">
              <div class="fondo-grisd2b">
                <v-row class="row1d2b">
                  <v-col cols="2">
                    <p class="programa-d2b">Programa</p>
                  </v-col>
                  <v-col
                    cols="10"
                    style="padding-left: 3vw;"
                    class="textocol1-d2b"
                  >
                    <p class="texto1d2b">
                      25 puestos de trabajo, pecera, sala de reuniones, muebles
                      de guardado, sector de juegos, acceso
                    </p>

                    <p class="texto1d2b"></p>
                  </v-col>
                </v-row>
                <v-row class="row2d2b">
                  <v-col cols="2">
                    <p class="programa-d2b">Colaboradores</p>
                  </v-col>
                  <v-col
                    cols="10"
                    style="padding-left: 3vw;"
                    class="textocol1-d2b"
                  >
                    <p class="texto1d2b">
                      Murales por

                      <a
                        href="https://www.instagram.com/matiulloa_/"
                        target="_blank"
                        style="font-family: 'Source-bold'; font-color: #372b5d !important;"
                        >@matiulloa_</a
                      >
                    </p>

                    <p class="texto1"></p>
                  </v-col>
                </v-row>
                <v-row class="row3d2b">
                  <v-col cols="2">
                    <p class="programa-d2b">Superficie</p>
                  </v-col>
                  <v-col
                    cols="10"
                    style="padding-left: 3vw;"
                    class="textocol1-d2b"
                  >
                    <p class="texto1d2b">138 m2</p>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div class="section" id="section3d2b" data-anchor="d2b3">
        <v-container fluid>
          <v-row>
            <v-col cols="6">
              <v-img :src="image_srcd2b4" class="img-d2b4" contain @click="setIndex(3)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
              <v-img :src="image_srcd2b3" class="img-d2b5" contain @click="setIndex(2)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
              <v-img :src="image_srcd2b5" class="img-d2b6" contain @click="setIndex(4)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
            <v-col cols="6">
              <div class="fondo-gris2d2b">
                <v-row>
                  <p class="texto2d2b">
                    Propuesta que se centró en generar areas lúdicas,
                    funcionales y amigables generando espacios que aportan al
                    bienestar de las personas y nuevas formas de trabajo que se
                    desarrollan en una planta libre, por lo que se propone un
                    diseño oficina que facilite las relaciones de manera más
                    transversal y dinámica, entendiendo las nuevas relaciones
                    laborales.
                  </p>
                </v-row>
                <v-row>
                  <p class="texto2d2b">
                    En este sentido la idea fue diseñar puestos de trabajo
                    movibles siendo oportunos para un trabajo individual como
                    colectivo utilizando colores limpios y vivaces con
                    mobiliarios más llamativos. Para generar un impacto visual
                    al entrar a las oficinas se propone un mural pintado a mano
                    en el acceso con un área de espera que también puede ser
                    usada para trabajar.
                  </p>
                </v-row>
              </div>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-container>
      </div>

      <div class="section" id="section4d2b" data-anchor="d2b4">
        <v-container fluid>
          <v-row>
            <v-col cols="4">
              <v-img :src="image_srcd2b" class="img-d2b3" cover @click="setIndex(0)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
            <v-col cols="8"> </v-col>
          </v-row>
        </v-container>
      </div>
    </full-page>
  </section>
</template>

<script>
import store from "../store";
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
  data() {
    return {
      proyectos: [
        {
          numero: 4,
          numeroString: "04",
          isActive: false,
          route: "/d2b",
          titulo: "Oficina D2B",
          resumen: "Restaurant comida fusión japonesa – hawaiana",
          lugar: "Santiago",
          año: "2020",
          programa:
            "Barra con pesca milagrosa, cocina caliente y fría en barra, baños",
          colaboradores: ["@manilawallart"],
          superficie: "300 m2 aprox.",
          descripcion: [
            "La propuesta tiene como finalidad generar un espacio único y atractivo, plasmando un estilo minimalista/industrial para crear una experiencia que integre diversas funciones.",
            "Dentro del encargo se pide Incorporar un elemento de impacto visual en vacío central proponiéndose un estructura trepable que une todos los pisos a través de un vacío central."
          ]
        }
      ],
      items: [
        {
          src: require("../assets/d2b.jpg"),
        },
        {
          src: require("../assets/d2b2.jpg"),
        },
        {
          src: require("../assets/d2b3.jpg"),
        },
        {
          src: require("../assets/d2b4.jpg"),
        },
        {
          src: require("../assets/d2b5.jpg"),
        },
      ],
      index: null,
      posicionLista: -25,
      proyectoSeleccionado: 4,
      image_srcd2b: require("../assets/d2b.jpg"),
      image_srcd2b2: require("../assets/d2b2.jpg"),
      image_srcd2b3: require("../assets/d2b3.jpg"),
      image_srcd2b4: require("../assets/d2b4.jpg"),
      image_srcd2b5: require("../assets/d2b5.jpg"),
      options: {
        licenseKey: "265864DA-1DE54052-9BEBB977-EF50CFB8",
        parallax: true,
        parallaxKey: [
          "Y29sZWN0aXZvYWxxdWltaWEuY2xfYmxNY0dGeVlXeHNZWGc9OTJR",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfdjhXY0dGeVlXeHNZWGc9QVEw",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfNjI0Y0dGeVlXeHNZWGc9WVlP"
        ],
        // parallaxKey: '7CD7B03B-68104BF5-88FFE8B4-2585F4CC',
        // activation-key for domain colectivoalquimia.cl: Y29sZWN0aXZvYWxxdWltaWEuY2xfcmg0Y0dGeVlXeHNZWGc9bHhi
        autoScrolling: true,
        scrollbar: false,
        slidesNavigation: false,
        controlArrows: false,
        anchors: ["d2b1", "d2b2", "d2b3", "d2b4"],
        verticalCentered: false,
        bigSectionsDestination: "top",
        scrollingSpeed: "700",
        parallaxOptions: {
          type: "cover",
          percentage: 99,
          property: "translate"
        },
        onLeave: function(origin, destination, direction) {
          console.log(destination);
          console.log(direction);
          if (origin.index == 0) {
            store.commit("esconder");
            document.getElementById("headerProy").style.top = "-60vh";
          } else if (origin.index == 1 && direction == "up") {
            //document.getElementById("headerProy").style.top = "0vw";
            // store.commit("mostrar");
          }
        },
        afterLoad: function(origin, destination, direction) {
          console.log(destination);
          console.log(direction);
          if (origin.index == 0) {
            setTimeout(function() {
              document.getElementById("headerProy").style.top = "0vh";
            }, 2000);
          } else if (origin.index == 1 && direction == "up") {
            //document.getElementById("headerProy").style.top = "0vw";
            // store.commit("mostrar");
          }
        }
      }
    };
  },
  components: {
    CoolLightBox
  },
  metaInfo: {
    title: "Proyectos",
    titleTemplate: "%s | Oficinas D2B"
  },
  computed: {
    yLista() {
      return `transform: translateY(${this.posicionLista}%)`;
    }
  },
  mounted() {
    setTimeout(function() {
      document.getElementById("headerProy").style.top = "-60vh";
    }, 2000);
    this.$refs.fullpage.api.moveTo(1, 0);
  },
  methods: {
    isOnTop() {
      if (this.$refs.fullpage.api.getActiveSection().anchor == "pro1") {
        return true;
      } else {
        return false;
      }
    },
    setIndex(index) {
      this.index = index;
    },
    getSection() {
      return this.$refs.fullpage.api.getActiveSection().anchor;
    },
    getSectionIndex() {
      return this.$refs.fullpage.api.getActiveSection().index;
    },
    selectTitle() {
      this.$refs.fullpage.api.moveTo(2);
    }
  }
};
</script>

<style>
.fp-bg {
  background-size: cover;
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden; /* Chrome, Safari, Opera */
  backface-visibility: hidden;
}
.container {
  padding: 0px;
  margin: 0px;
  transition: all 0.45s ease-in-out;
  transition: all 0.45s cubic-bezier(0.55, 0, 0.1, 1);
}
.section {
  height: 100vh;
  z-index: -1;
}
#section1d2b {
  background-image: url("../assets/d2b.jpg");
  background-size: cover;
  background-position: center 50%;
}
#section2d2b {
  background-size: cover;
}
#section3d2b {
  background-size: cover;
}
#section4d2b {
  background-size: cover;
}
#slide1-1 .fp-bg {
  background-image: url("../assets/1.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-2 .fp-bg {
  background-image: url("../assets/2.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-3 .fp-bg {
  background-image: url("../assets/3.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-4 .fp-bg {
  background-image: url("../assets/4.jpg");
  background-size: cover;
  background-position: center 80%;
}
.titulo-apiadate {
  position: absolute;
  height: 6vw;
  top: 40vh;
  padding: 0em;
  font-size: calc(14.5px + 2.98125vw);
  font-family: "Source-bold";
  color: white;
  text-decoration: none;
  text-shadow: 0px 0px #000000;
  transition-duration: 625ms;
  transition: opacity 0.5s, transform 0.5s;
  z-index: 99;
}
.headerProyecto-d2b {
  position: fixed;
  top: 0;
  background-color: #fff;
  height: 60vh;
  width: 100%;
  transition: 925ms;
  z-index: 999;
}

@media (min-width: 960px) {
  .texto1d2b {
    font-size: calc(4.5px + 1.01875vw);
    color: black;
    padding-left: 10px;
    padding-right: 5vw;
    font-family: "Source";
  }
  .texto2d2b {
    top: 2vh;
    font-size: calc(2.5px + 0.91875vw);
    color: black;
    padding-right: 1vw;
  }
  .img-d2b2 {
    top: 1vh;
    left: 1vw;
    position: absolute;
    width: 60vw;
    cursor: pointer;
  }
  .img-d2b3 {
    position: absolute;
    height: 95vh;
    left: 15vw;
    cursor: pointer;
  }
  .img-d2b4 {
    position: absolute;
    bottom: 1vh;
    left: 5vw;
    padding: 5vw;
    width: 40vw;
    z-index: 1;
    cursor: pointer;
  }
  .img-d2b5 {
    position: absolute;
    bottom: 1vh;
    right: 5vw;
    padding: 5vw;
    width: 40vw;
    z-index: 1;
    cursor: pointer;
  }
  .img-d2b6 {
    position: absolute;
    right: 50vw;
    top: 1vh;
    width: 40vw;
    z-index: 1;
    cursor: pointer;
  }
  .programa-d2b {
    color: black;
    white-space: pre;
    font-size: calc(4.5px + 0.68125vw);
  }
  .fondo-grisd2b {
    position: absolute;
    background-color: #e3dfe0 !important;
    right: 2vw;
    top: 10vh;
    margin-top: 0;
    max-width: 35vw;
    min-height: 30vh;
    padding-left: 1vw;
    padding-right: 0vw;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .fondo-gris2d2b {
    left: 5vw;
    position: relative;
    background-color: #e3dfe0 !important;
    right: 5vw;
    padding-left: 2vw;
    padding-right: 1vw;
    margin-right: 5vw;
    max-width: 40vw;
    min-height: 45vh;
    max-height: 80vh;
    padding-top: 50px;
    padding-bottom: 1vh;
  }
  .proyectos {
    position: fixed;
    top: 55vh;
    width: 50vw;
    left: 15vw;
    z-index: 99;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  li {
    height: 6vw;
  }
  .nProyecto {
    position: relative;
    bottom: 6vh;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nTotalProyectos {
    position: fixed;
    bottom: 5vh;
    left: 15vw;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.5;
  }
  .titulo-proyecto-d2b {
    position: absolute;
    font-family: "Didot-bold";
    color: black;
    font-size: calc(14.5px + 2.18125vw);
    top: 15vh;
    left: 25vw;
  }
  .titulo-proyecto-d2b::before {
    content: "";
    position: absolute;
    top: 35px;
    right: 100%;
    cursor: default;
    width: 1.5em;
    height: 3px;
    background: #000;
    z-index: 3;
  }
  .subtitulo-proyecto {
    font-family: "Source";
    font-size: calc(10.5px + 1.78125vw);
  }
  .boton-volver-d2b {
    position: absolute;
    font-family: "Source";
    bottom: 3vh;
    left: 25vw;
    z-index: 9999;
  }
}

@media (max-width: 960px) {
  .texto1d2b {
    position: relative;
    top: 5vh;
    font-size: calc(7.5px + 1.01875vw);
    color: black;
    padding-right: 1vw;
    padding-top: 0vh;
    margin-left: 0vw;
    padding-left: 0vw;
    padding: 0;
    max-width: 45vw;
  }
  .texto2d2b {
    top: 5vh;
    font-size: calc(5.5px + 1.01875vw);
    color: black;
    padding-right: 1vw;
  }
  .boton-volver {
    position: absolute;
    font-family: "Source";
    bottom: 20vw;
    left: 5vw;
    z-index: 9999;
  }
  .img-d2b {
    top: 10vh;
    right: 0vw;
    position: absolute;
    width: 125%;
    z-index: 0;
  }
  .img-d2b2 {
    top: 10vh;
    right: 0vw;
    position: absolute;
    width: 125%;
    z-index: 0;
  }
  .img-d2b3 {
    position: absolute;
    top: 20vh;
    left: 3vw;
    width: 94vw;
  }
  .img-d2b4 {
    position: absolute;
    top: 14vh;
    left: 1vw;
    height: 20vh;
    max-width: 44vw;
    z-index: 1;
  }
  .img-d2b5 {
    position: absolute;
    top: 34vh;
    left: 1vw;
    padding: 5vw;
    height: 20vh;
    max-width: 44vw;
    z-index: 1;
  }
  .img-d2b6 {
    position: absolute;
    top: 54vh;
    left: 1vw;
    height: 20vh;
    max-width: 44vw;
    z-index: 1;
  }
  .row1d2b {
    position: relative;
    margin-top: 1px;
    min-height: 5vh;
  }
  .row2d2b {
    position: relative;
    margin-top: 1px;
    min-height: 5vh;
  }
  .row3d2b {
    position: relative;
    margin-top: 1px;
    min-height: 5vh;
  }
  .fondo-grisd2b {
    position: relative;
    top: 35vh;
    right: 5vw;
    background-color: #e3dfe0 !important;
    max-width: 70vw;
    min-width: 50vw;
    max-height: 80vh;
    padding-right: 15px;
    z-index: 5;
  }
  .fondo-gris2d2b {
    position: relative;
    background-color: #e3dfe0 !important;
    min-height: 60vh;
    max-height: 95vh;
    min-width: 50vw;
    max-width: 70vw;
    padding: 7vw;
    margin-top: 10vh;
    padding-bottom: 2vh;
    top: 1vh;
    right: 7vw;
  }
  .textocol1-d2b {
    line-height: 1.5;
  }
  .programa-d2b {
    position: relative;
    min-height: 5vh;
    top: 0vh;
    margin-bottom: 3vh;
    padding-left: 2vw;
    color: black;
    white-space: pre;
    font-size: calc(4.5px + 1.98125vw);
  }
  .proyectos {
    position: fixed;
    top: 60vh;
    width: 50vw;
    left: 15vw;
    z-index: 99;
    white-space: nowrap;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  li {
    white-space: nowrap;
  }
  .nProyecto {
    position: relative;
    bottom: 4vh;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 60px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nTotalProyectos {
    position: fixed;
    bottom: 15vh;
    left: 15vw;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.5;
  }
  .titulo-proyecto-d2b {
    position: absolute;
    font-family: "Didot-bold";
    color: black;
    font-size: calc(20.5px + 2.18125vw);
    top: 20vh;
    left: 25vw;
  }
  .titulo-proyecto-d2b::before {
    content: "";
    position: absolute;
    top: 20px;
    right: 100%;
    cursor: default;
    width: 1.5em;
    height: 2px;
    background: #000;
    z-index: 9999;
  }
  .subtitulo-proyecto {
    font-family: "Source";
    font-size: calc(10.5px + 1.78125vw);
  }
  .texto-card {
    font-family: "Source";
    font-size: 20px;
    font-weight: 400;
    padding-top: 20px;
    color: #ffffff;
    line-height: 1;
  }
  .boton-volver-d2b {
    position: relative;
    font-family: "Source";
    top: 50vw;
    left: 10vw;
    z-index: 9999;
  }
}
</style>
